var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-steel-1219387 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0271 13.274L9.32812 14.1039V19.4759L14.0271 13.274Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.07422 20.758L6.59702 19.7858V15.262L1.07422 20.758Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.03779 20.0282V13.861L14.3442 12.9226L15.1367 12.7851V11.0463H0.788086V12.7851L6.88709 13.8608V20.028L0.788086 21.1034V22.8396H15.1375V21.1041L9.16029 20.0491L9.03779 20.0282Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.2758 6.07899L15.4284 12.96V13.0279L14.4476 13.2002L9.44336 19.8066L15.2036 20.8206L22.8432 6.31101L21.2758 6.07899Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.0299 2.16008H18.0461L1.24512 10.7589H15.2187L23.0299 2.16008Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.4277 22.372L22.9213 7.4262V6.78394L15.4277 21.0161V22.372Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.4277 12.51L23.2117 3.3544H23.212V2.3894L15.4278 10.959L15.4277 12.51Z",
    fill: "#656565"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetals);
export default __webpack_public_path__ + "static/media/metals.5adb444bccde35abb1a1767e3ade5be8.svg";
export { ForwardRef as ReactComponent };